<div class="flex gap-2 flex-col">
    @for (option of selectOptions; track option) {
        <div class="flex gap-2 w-full h-full">
            <div class="h-5 w-5 rounded" [style.background-color]="option.color"></div>
            <div class="flex">
                @if (option.icon) {
                    <app-tb-icon class="mr-1" [icon]="option.icon"></app-tb-icon>
                }
                <span>{{ option.label }}</span>
            </div>
        </div>
    }
</div>
